/**
 * Eluno Smart Search — Live Theme
 * Cloudflare Worker → Algolia + Claude AI
 * Features: displayHint · recent searches (localStorage) · popular searches (API)
 */
(function () {
  'use strict';

  var WORKER_URL  = 'https://eluno-search-worker.longivitate.workers.dev/search';
  var POPULAR_URL = 'https://eluno-search-worker.longivitate.workers.dev/popular-searches';
  var RECENT_KEY  = 'eluno_recent_v1';
  var MAX_RECENT  = 6;

  /* Algolia direct access (search-only key — safe for frontend) */
  var ALGOLIA_APP_ID   = '2YWZ9S7CJI';
  var ALGOLIA_KEY      = '806f71716c06e5c296da54db12463bff';
  var ALGOLIA_INDEX    = 'eluno_products';
  var ALGOLIA_DSN      = 'https://' + ALGOLIA_APP_ID + '-dsn.algolia.net/1/indexes/' + ALGOLIA_INDEX + '/query';

  /* SKU pattern: exactly 7 digits */
  var SKU_REGEX = /^\d{7}$/;

  var overlay, container, searchInput, clearBtn, cancelBtn,
      recentWrap, recentList, popularWrap, popularList,
      loadingSection, resultsSection,
      displayHintEl, resultsList, resultsFooter, viewAllLink,
      noResultsSection, noResultsQuery;

  var debounceTimer  = null;
  var lastNbHits     = 0;
  var popularFetched = false;

  // ── Init ───────────────────────────────────────────────────────────────────

  function init() {
    overlay = document.getElementById('eluno-search-overlay');
    if (!overlay) return;

    container        = overlay.querySelector('.eluno-search-container');
    searchInput      = document.getElementById('eluno-search-input');
    clearBtn         = document.getElementById('eluno-search-clear');
    cancelBtn        = document.getElementById('eluno-search-cancel');
    recentWrap       = document.getElementById('eluno-recent-wrap');
    recentList       = document.getElementById('eluno-recent-list');
    popularWrap      = document.getElementById('eluno-popular-wrap');
    popularList      = document.getElementById('eluno-popular-list');
    loadingSection   = document.getElementById('eluno-loading');
    resultsSection   = document.getElementById('eluno-results');
    displayHintEl    = document.getElementById('eluno-display-hint');
    resultsList      = document.getElementById('eluno-results-list');
    resultsFooter    = document.getElementById('eluno-results-footer');
    viewAllLink      = document.getElementById('eluno-view-all');
    noResultsSection = document.getElementById('eluno-no-results');
    noResultsQuery   = document.getElementById('eluno-no-results-query');

    bindSearchTriggers();
    bindInputEvents();
    bindCloseEvents();
  }

  // ── Intercept native search triggers ──────────────────────────────────────

  function bindSearchTriggers() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.header__icon--search, .modal__toggle-search-mobile, .modal__toggle-open');
      if (!trigger) return;
      if (!trigger.closest('[id*="header"], header, .site-header')) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      openModal();
    }, true);
  }

  // ── Input events ───────────────────────────────────────────────────────────

  function bindInputEvents() {
    searchInput.addEventListener('input', function () {
      var raw = searchInput.value;
      clearBtn.hidden = !raw.length;
      if (debounceTimer) clearTimeout(debounceTimer);
      if (!raw.trim()) { showSection('popular'); return; }
      showSection('loading');
      debounceTimer = setTimeout(function () { runSearch(raw.trim().toLowerCase()); }, 340);
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = searchInput.value.trim().toLowerCase();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      }
    });

    clearBtn.addEventListener('click', function () {
      searchInput.value = '';
      clearBtn.hidden = true;
      lastNbHits = 0;
      showSection('popular');
      searchInput.focus();
    });
  }

  // ── Close / delegate click events ─────────────────────────────────────────

  function bindCloseEvents() {
    cancelBtn.addEventListener('click', closeModal);

    overlay.addEventListener('click', function (e) {
      if (!container.contains(e.target)) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
    });

    // Clicking a recent or popular search item
    overlay.addEventListener('click', function (e) {
      var item = e.target.closest('.eluno-popular-item, .eluno-recent-item');
      if (!item) return;
      var termEl = item.querySelector('.eluno-search-term');
      var term   = item.dataset.term || (termEl && termEl.textContent.trim()) || item.textContent.trim();
      var normTerm = term.trim().toLowerCase();
      searchInput.value = term;
      clearBtn.hidden   = false;
      showSection('loading');
      if (debounceTimer) clearTimeout(debounceTimer);
      runSearch(normTerm);
    });
  }

  // ── Modal open / close ─────────────────────────────────────────────────────

  function openModal() {
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.classList.add('eluno-search-open');
    searchInput.value = '';
    clearBtn.hidden   = true;
    lastNbHits        = 0;
    renderPopularSection();
    showSection('popular');
    loadPopularSearches();
    setTimeout(function () { searchInput.focus(); }, 120);
  }

  function closeModal() {
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.classList.remove('eluno-search-open');
    if (debounceTimer) clearTimeout(debounceTimer);
  }

  // Show one of: 'popular' | 'loading' | 'results' | 'no-results'
  function showSection(name) {
    var showPopular = name === 'popular';
    if (popularWrap) popularWrap.hidden = !showPopular;
    if (recentWrap && !showPopular) recentWrap.hidden = true;
    if (loadingSection)   loadingSection.hidden   = name !== 'loading';
    if (resultsSection)   resultsSection.hidden   = name !== 'results';
    if (noResultsSection) noResultsSection.hidden = name !== 'no-results';
  }

  // ── Recent searches (localStorage) ────────────────────────────────────────

  function getRecentSearches() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveRecentSearch(query, displayHint) {
    try {
      var recents = getRecentSearches().filter(function (r) {
        return r.query.toLowerCase() !== query.toLowerCase();
      });
      recents.unshift({ query: query, displayHint: displayHint || '', ts: Date.now() });
      localStorage.setItem(RECENT_KEY, JSON.stringify(recents.slice(0, MAX_RECENT)));
    } catch (e) { /* storage full */ }
  }

  function renderPopularSection() {
    var recents = getRecentSearches();

    if (recents.length > 0 && recentWrap && recentList) {
      recentList.innerHTML = '';
      recents.forEach(function (r) {
        var li  = document.createElement('li');
        var btn = document.createElement('button');
        btn.type      = 'button';
        btn.className = 'eluno-recent-item';
        btn.dataset.term = r.query;
        btn.innerHTML =
          '<svg class="eluno-popular-icon" fill="none" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">' +
            '<path d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
          '</svg>' +
          '<span class="eluno-search-term">' + esc(r.query) + '</span>' +
          (r.displayHint
            ? '<span class="eluno-search-hint">' + esc(r.displayHint) + '</span>'
            : '');
        li.appendChild(btn);
        recentList.appendChild(li);
      });
      recentWrap.hidden = false;
    } else if (recentWrap) {
      recentWrap.hidden = true;
    }
  }

  // ── Popular searches (worker API) ──────────────────────────────────────────

  function loadPopularSearches() {
    if (popularFetched) return;

    try {
      var cached = sessionStorage.getItem('eluno_popular_v1');
      if (cached) {
        var obj = JSON.parse(cached);
        if (obj.ts && Date.now() - obj.ts < 3600000 && obj.searches && obj.searches.length) {
          renderPopularList(obj.searches);
          popularFetched = true;
          return;
        }
      }
    } catch (e) { /* ignore */ }

    fetch(POPULAR_URL)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var searches = (data && data.searches) || [];
        if (searches.length) {
          renderPopularList(searches);
          try {
            sessionStorage.setItem('eluno_popular_v1',
              JSON.stringify({ searches: searches, ts: Date.now() }));
          } catch (e) { /* ignore */ }
        }
        popularFetched = true;
      })
      .catch(function () { popularFetched = true; });
  }

  function renderPopularList(searches) {
    if (!popularList || !searches.length) return;
    popularList.innerHTML = '';
    searches.forEach(function (term) {
      var li  = document.createElement('li');
      var btn = document.createElement('button');
      btn.type      = 'button';
      btn.className = 'eluno-popular-item';
      btn.dataset.term = term;
      btn.innerHTML =
        '<svg class="eluno-popular-icon" fill="none" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">' +
          '<path d="M10.364 3a7.364 7.364 0 1 0 0 14.727 7.364 7.364 0 0 0 0-14.727Z" stroke="currentColor" stroke-width="1.5"/>' +
          '<path d="M15.857 15.858 21 21.001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg>' +
        esc(term);
      li.appendChild(btn);
      popularList.appendChild(li);
    });
  }

  // ── Search ─────────────────────────────────────────────────────────────────

  /* Direct Algolia call — used for SKU lookups and as the internal renderer */
  function algoliaSearch(algoliaQuery, filters, hitsPerPage, callback) {
    var body = { query: algoliaQuery, hitsPerPage: hitsPerPage, page: 0,
      attributesToRetrieve: ['title','handle','vendor','price','compare_at_price','image_url','featured_image','inventory'] };
    if (filters) body.filters = filters;
    fetch(ALGOLIA_DSN, {
      method: 'POST',
      headers: {
        'X-Algolia-Application-Id': ALGOLIA_APP_ID,
        'X-Algolia-API-Key': ALGOLIA_KEY,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
    .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    .then(callback)
    .catch(function(err) { callback({ hits: [], nbHits: 0, error: err.message }); });
  }

  function runSearch(query) {
    var sentQuery = query;

    /* ── SKU detection: 7-digit numeric → direct Algolia filter, skip Worker ── */
    if (SKU_REGEX.test(query)) {
      console.log('[Eluno Search] SKU detected:', query);
      algoliaSearch('', 'sku:' + query, 6, function(data) {
        if (sentQuery !== searchInput.value.trim().toLowerCase()) return;
        lastNbHits = data.nbHits || 0;
        if (!data.hits || data.hits.length === 0) {
          noResultsQuery.textContent = sentQuery;
          showSection('no-results');
        } else {
          renderResults(data.hits, sentQuery, lastNbHits, 'Exact SKU Match');
          showSection('results');
        }
      });
      return;
    }

    /* ── NL / frame-name search via Worker (Claude AI + Algolia) ─────────────── */
    fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query, hitsPerPage: 6 })
    })
    .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
    .then(function (data) {
      if (sentQuery !== searchInput.value.trim().toLowerCase()) return;
      lastNbHits = data.nbHits || 0;
      var hint   = data.display_hint || '';
      console.log('[Eluno Search] Worker → intent:', data.intent, '| filters:', data.filters_applied, '| nbHits:', lastNbHits);

      if (lastNbHits > 0) saveRecentSearch(sentQuery, hint);

      if (!data.hits || data.hits.length === 0) {
        noResultsQuery.textContent = sentQuery;
        showSection('no-results');
      } else {
        renderResults(data.hits, sentQuery, lastNbHits, hint);
        showSection('results');
      }
    })
    .catch(function (err) {
      console.error('[Eluno Search]', err);
      if (sentQuery === searchInput.value.trim().toLowerCase()) {
        noResultsQuery.textContent = sentQuery;
        showSection('no-results');
      }
    });
  }

  // ── Render results ─────────────────────────────────────────────────────────

  function renderResults(hits, query, totalHits, hint) {
    if (displayHintEl) {
      if (hint) {
        displayHintEl.textContent = hint;
        displayHintEl.hidden = false;
      } else {
        displayHintEl.hidden = true;
      }
    }

    resultsList.innerHTML = '';
    hits.forEach(function (hit) {
      var a      = document.createElement('a');
      a.href     = '/products/' + hit.handle;
      a.className = 'eluno-result-card';
      var imgSrc = hit.featured_image || hit.image_url || '';
      if (imgSrc) imgSrc += '?width=144&height=144&crop=center';
      a.innerHTML =
        '<div class="eluno-result-img-wrap">' +
          (imgSrc
            ? '<img src="' + imgSrc + '" alt="' + esc(hit.title) + '" class="eluno-result-img" loading="lazy" width="72" height="72">'
            : '') +
        '</div>' +
        '<div class="eluno-result-info">' +
          '<div class="eluno-result-name">' + esc(hit.title) + '</div>' +
          '<div class="eluno-result-price-row">' + formatPriceHtml(hit.price, hit.compare_at_price) + '</div>' +
        '</div>';
      resultsList.appendChild(a);
    });

    viewAllLink.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
    viewAllLink.textContent = totalHits > hits.length
      ? 'View all ' + totalHits + ' results \u2192'
      : 'View all results \u2192';
    resultsFooter.hidden = false;
  }

  // ── Price helpers ──────────────────────────────────────────────────────────

  function formatPriceHtml(price, compareAtPrice) {
    var s = fmtRupee(price);
    if (!compareAtPrice || compareAtPrice <= price)
      return '<span class="eluno-result-price">' + s + '</span>';
    var pct = Math.round((1 - price / compareAtPrice) * 100);
    return '<span class="eluno-result-price">' + s + '</span>' +
           '<span class="eluno-result-compare">' + fmtRupee(compareAtPrice) + '</span>' +
           (pct > 0 ? '<span class="eluno-result-badge">' + pct + '% off</span>' : '');
  }

  function fmtRupee(n) { return '\u20B9' + Math.round(n).toLocaleString('en-IN'); }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
